var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError } from "axios";
import { call, getContext, put, takeEvery, } from "redux-saga/effects";
import { InviteUser } from "../constants/invite_user";
import { APIType } from "../services/authenticationService";
function inviteUserToOrganisation(action) {
    var callAPI, response, error_1, errorMessage;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_c.sent()).callAPI;
                _c.label = 2;
            case 2:
                _c.trys.push([2, 6, , 8]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.POST, "/api/invite_user_to_organisation/", {
                            body: {
                                email: action.email,
                                organisation_id: action.organisation_id,
                                role: action.role,
                            },
                        });
                    })];
            case 3:
                response = _c.sent();
                if (!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put({
                        type: InviteUser.InviteUserToOrganisation_Successful,
                        payload: "Invitation sent to ".concat(action.email),
                    })];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5: return [3 /*break*/, 8];
            case 6:
                error_1 = _c.sent();
                errorMessage = "Failed to send invitation";
                if (error_1 instanceof AxiosError && ((_b = (_a = error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error)) {
                    errorMessage = error_1.response.data.error;
                }
                return [4 /*yield*/, put({
                        type: InviteUser.InviteUserToOrganisation_Error,
                        payload: errorMessage,
                    })];
            case 7:
                _c.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function inviteUserToSuperorg(action) {
    var callAPI, response, error_2, errorMessage;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_c.sent()).callAPI;
                _c.label = 2;
            case 2:
                _c.trys.push([2, 6, , 8]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.POST, "/api/invite_user_to_superorg/", {
                            body: {
                                email: action.email,
                                superorg_id: action.superorg_id,
                                role: action.role,
                            },
                        });
                    })];
            case 3:
                response = _c.sent();
                if (!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put({
                        type: InviteUser.InviteUserToSuperorg_Successful,
                        payload: "Invitation sent to ".concat(action.email),
                    })];
            case 4:
                _c.sent();
                _c.label = 5;
            case 5: return [3 /*break*/, 8];
            case 6:
                error_2 = _c.sent();
                errorMessage = "Failed to send invitation";
                if (error_2 instanceof AxiosError && ((_b = (_a = error_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error)) {
                    errorMessage = error_2.response.data.error;
                }
                return [4 /*yield*/, put({
                        type: InviteUser.InviteUserToSuperorg_Error,
                        payload: errorMessage,
                    })];
            case 7:
                _c.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function fetchPendingInvitesSaga(action) {
    var callAPI, endpoint_1, response, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_b.sent()).callAPI;
                _b.label = 2;
            case 2:
                _b.trys.push([2, 8, , 10]);
                endpoint_1 = "/api/pending_invites/";
                if (action.org_id) {
                    endpoint_1 +=
                        action.user_type === "organisation"
                            ? "?organisation_id=".concat(action.org_id)
                            : "?superorg_id=".concat(action.org_id);
                }
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.GET, endpoint_1)
                            .then(function (resp) { return resp.data; })
                            .catch(function () { return null; });
                    })];
            case 3:
                response = _b.sent();
                if (!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put({ type: InviteUser.FetchPendingInvites_Successful, payload: response })];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, put({ type: InviteUser.FetchPendingInvites_Error })];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7: return [3 /*break*/, 10];
            case 8:
                _a = _b.sent();
                return [4 /*yield*/, put({ type: InviteUser.FetchPendingInvites_Error })];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function revokeInviteSaga(action) {
    var callAPI, response, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_b.sent()).callAPI;
                _b.label = 2;
            case 2:
                _b.trys.push([2, 8, , 10]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.POST, "/api/revoke_invite/", { body: { token: action.token } })
                            .then(function (resp) { return resp.data; })
                            .catch(function () { return null; });
                    })];
            case 3:
                response = _b.sent();
                if (!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put({ type: InviteUser.RevokeInvite_Successful, token: action.token })];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, put({ type: InviteUser.RevokeInvite_Error })];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7: return [3 /*break*/, 10];
            case 8:
                _a = _b.sent();
                return [4 /*yield*/, put({ type: InviteUser.RevokeInvite_Error })];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function resendInviteSaga(action) {
    var callAPI, response, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, getContext("authService")];
            case 1:
                callAPI = (_b.sent()).callAPI;
                _b.label = 2;
            case 2:
                _b.trys.push([2, 8, , 10]);
                return [4 /*yield*/, call(function () {
                        return callAPI(APIType.POST, "/api/resend_invite/", { body: { token: action.token } })
                            .then(function (resp) { return resp.data; })
                            .catch(function () { return null; });
                    })];
            case 3:
                response = _b.sent();
                if (!response) return [3 /*break*/, 5];
                return [4 /*yield*/, put({ type: InviteUser.ResendInvite_Successful })];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, put({ type: InviteUser.ResendInvite_Error })];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7: return [3 /*break*/, 10];
            case 8:
                _a = _b.sent();
                return [4 /*yield*/, put({ type: InviteUser.ResendInvite_Error })];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
export default function InviteUserSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(InviteUser.InviteUserToOrganisation, inviteUserToOrganisation)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeEvery(InviteUser.InviteUserToSuperorg, inviteUserToSuperorg)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(InviteUser.FetchPendingInvites, fetchPendingInvitesSaga)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(InviteUser.RevokeInvite, revokeInviteSaga)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeEvery(InviteUser.ResendInvite, resendInviteSaga)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
